import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IAddressInfo } from "../interface/ITrader";
import { GetAddressbyTraderIdParamModel } from "../model/address";
import AddressService from "../service/AddressService";

import { RootState } from "../store/store";

import { logoutUser } from "./common";

export const resetAddress = createAction("address/reset");

const _service = new AddressService();

export const getAddressAsync = createAsyncThunk(
  "address/address",
  async (params: GetAddressbyTraderIdParamModel) => {
    const response = await _service.getAddresService(params);
    return response;
  }
);

export const getLiveAddressAsync = createAsyncThunk(
  "trader/getALiveAddress",
  async (params: GetAddressbyTraderIdParamModel) => {
    const response = await _service.getLiveAddressService(params);
    return response;
  }
);



type SliceState = {
  value: IAddressInfo[] | null;
  status: string;
  apiCallCount: number;
  traderLive:boolean;
  currentUnpaid: number;
  unpaid30Days: number;
  unpaid60Days: number;
  unpaid90Days: number;
  unpaidGreaterThan90Days: number;
  unpaidTotal: number | null;
  currentPaid: number | null;
  showOverdueAccountMessageCart: boolean;
  showOverdueAccountMessageStandingOrder: boolean;
  showOverdueAccountMessageLateOrder: boolean;
};
const initialState = {
  value: null,
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
  traderLive: false,
  currentUnpaid: 0,
  unpaid30Days: 0,
  unpaid60Days: 0,
  unpaid90Days: 0,
  unpaidGreaterThan90Days: 0,
  unpaidTotal: null,
  currentPaid: null,
  showOverdueAccountMessageCart: false,
  showOverdueAccountMessageStandingOrder: false,
  showOverdueAccountMessageLateOrder: false,
} as SliceState;

export const addressRuleSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    updateAddresses: (state: SliceState, action) => {
      if (state && state.value) {
        state.value.map((m: IAddressInfo) => {
          const found = action.payload.find((aId: number) => m.id === aId);
          m.live = found > 0;
        });

      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddressAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getAddressAsync.fulfilled, (state: SliceState, action) => {
        state.value = action.payload.addresses;
        state.traderLive =  action.payload.traderLive;
        state.currentUnpaid = action.payload.currentUnpaid || 0;
        state.unpaid30Days = action.payload.unpaid30Days || 0;
        state.unpaid60Days = action.payload.unpaid60Days || 0;
        state.unpaid90Days = action.payload.unpaid90Days || 0;
        state.unpaidGreaterThan90Days = action.payload.unpaidGreaterThan90Days || 0;
        state.unpaidTotal = action.payload.unpaidTotal;
        state.currentPaid = action.payload.currentPaid;
        state.status = COMMON_STATUS.LOADED;
        state.apiCallCount = 0;
      })
      .addCase(getAddressAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount += 1;
      })
      .addCase(getLiveAddressAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getLiveAddressAsync.fulfilled, (state: SliceState, action) => {
        if (state && state.value) {
          state.value.map((m: IAddressInfo) => {
            const found = action.payload.find((aId: number) => m.id === aId);
            m.live = found > 0;
          });
  
        }
        state.status = COMMON_STATUS.LOADED;
        state.apiCallCount = 0;
      })
      .addCase(getLiveAddressAsync.rejected, (state: SliceState) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount += 1;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetAddress, () => {
        return initialState;
      });
  },
});

export const { updateAddresses } = addressRuleSlice.actions;
export const getAddress = (state: RootState) => state.address;
export const getLiveAddresses = (state: RootState) => state.address?.value?.filter((add) => {
  return add.live;
});
export const getAddressStatus = (state: RootState) => state.address?.status;
export default addressRuleSlice.reducer;
export const getUnpaidAmounts = (state: RootState) => ({
  currentUnpaid: state.address?.currentUnpaid || 0,
  unpaid30Days: state.address?.unpaid30Days || 0,
  unpaid60Days: state.address?.unpaid60Days || 0,
  unpaid90Days: state.address?.unpaid90Days || 0,
  unpaidGreaterThan90Days: state.address?.unpaidGreaterThan90Days || 0,
  unpaidTotal: state.address?.unpaidTotal || 0,
  currentPaid: state.address?.currentPaid || 0,
});

export const getShowOverdueMessages = (state: RootState) => ({
  showOverdueAccountMessageCart: state.address?.value?.[0]?.trader?.showOverdueAccountMessageCart ?? false,
  showOverdueAccountMessageStandingOrder: state.address?.value?.[0]?.trader?.showOverdueAccountMessageStandingOrder ?? false,
  showOverdueAccountMessageLateOrder: state.address?.value?.[0]?.trader?.showOverdueAccountMessageLateOrder ?? false,
});